import React from "react";
import {
    TableCell,
    Table,
    TableBody,
    TableRow,
    TableHead,
    Button
} from '@mui/material'
import { RoutePaths } from '../../Routes'
import Bookings from '../../../models/Bookings';
import EditIcon from '@mui/icons-material/Edit'
import ClearIcon from '@mui/icons-material/Clear'
import { Temporal } from '@js-temporal/polyfill';
import WarningModal from '../../administration/EditEvent/WarningModal'
import { withRouter } from "../../Shared/withNavigate";

class Registrations extends React.Component<any, any> {

    componentDidMount() {
        setTimeout(() => {
            this.props.fetch()
        }, 900)
    }

    itemToDelete: number = null

    public render() {
        const columnNames: string[] = ['PersonalNr', 'Verantwortlicher', 'Anmeldedatum', 'Anmeldungen', 'Betrag',
            'Bezahldatum', 'Zahlungsart', 'Status', 'Aktionen']

        let tableColumns = columnNames.map(x => {
            return <TableCell key={x}>{x}</TableCell>
        })

        let rows = (this.props.bookings as Bookings[]).map(x => {
            const instant = Temporal.Instant.from(new Date(x.bookingDate).toISOString());
            const date = instant.toZonedDateTimeISO('UTC').toPlainDate();
            const formattedDate = `${date.day.toString().padStart(2, '0')}.${date.month
                .toString()
                .padStart(2, '0')}.${date.year}`;
            const sum = x.bookingAlternativePrice != null ? x.bookingAlternativePrice : x.bookingTotal
            return <TableRow key={x.id}>
                <TableCell>{x.bookingResponsibleUser.personalNr}</TableCell>
                <TableCell>{`${x.bookingResponsibleUser.firstname} ${x.bookingResponsibleUser.lastname}`}</TableCell>
                <TableCell>{formattedDate}</TableCell>
                <TableCell>{x.membersCount}</TableCell>
            <TableCell>{`€ ${typeof sum != 'undefined' && sum ? sum.toFixed(2).replace('.',',') : '0,-'}`}</TableCell>
            <TableCell>
                {x.paymentDate
                ? Temporal.Instant.from(new Date(x.paymentDate).toISOString())
                            .toZonedDateTimeISO('UTC') 
                            .toPlainDate()
                            .toString()
                            .split('-')
                            .reverse()
                            .join('.')
                : ''}
            </TableCell>
                <TableCell>{x.paymentTypeName}</TableCell>
                <TableCell>{x.paymentStatusName}</TableCell>
                <TableCell>
                    <EditIcon className='icon' onClick={() => this.props.router.navigate(`${RoutePaths.AddBooking}?eventId=${this.props.eventId}&bookingId=${x.id}`)}/>
                    <ClearIcon className='icon' onClick={() => {
                        this.itemToDelete = x.id
                        this.props.showWarningModalFunc()
                    }}/>
                </TableCell>
            </TableRow>
        })

        return (
            <div className='card'>
                <div className='card-header'>
                    Anmeldungen
            </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-lg-3 col-md-3 col-sm-3 col-xs-3 d-flex'>
                            <Button
                                variant='contained'
                                color='primary'
                                className='btnBlue'
                                onClick={() => this.props.router.navigate(`${RoutePaths.AddBooking}?eventId=${this.props.eventId}`)}>Hinzufügen</Button>
                        </div>
                    </div>
                    <div className='row mt-4'>
                        <Table className="objects-table table">
                            <TableHead>
                                <TableRow>
                                    {tableColumns}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                {
                    this.props.showWarningModal &&
                    <WarningModal 
                        text={'Anmeldung wird gelöscht! Sind Sie sicher?'}
                        confirm={() => this.props.delete(this.itemToDelete)}
                        hide={this.props.hideWaringModal}/>
                }
            </div>
        )
    }
}

export default withRouter(Registrations)